<template>
  <el-main class="common-main">
    <div class="container">
      <el-row class="tac" :gutter="20">
        <el-col :span="4">
          <TheLeft></TheLeft>
        </el-col>
        <el-col :span="20">
          <div class="order-content">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="全部课程" name="0"></el-tab-pane>
              <el-tab-pane label="学习中课程" name="1"></el-tab-pane>
              <el-tab-pane label="已过期课程" name="2"></el-tab-pane>
              <el-tab-pane label="已关闭课程" name="3"></el-tab-pane>
            </el-tabs>
            <div class="order-box" v-loading="loading">
              <div class="order-list" v-if="courses.length > 0">
                <div class="order-item" v-for="(item, index) in courses" :key="index" v-if="item.study">
                  <div class="order-item-header">
                    <div>开通时间：{{ item.created_at }}</div>
                    <div v-if="item.status === 1 && item.rebuild === 0" @click="lookAgreement(index)" class="look-agreement">查看协议</div>
                  </div>
                  <div class="order-item-content">
                    <el-row :gutter="20">
                      <el-col :span="4">
                        <img
                            :src="item.study.images && item.study.images.length > 0 ? path + item.study.images[0] : noneImg"
                            :alt="item.study.title" class="cart-item-img">
                      </el-col>
                      <el-col :span="10">
                        <router-link :to="{path: '/course/'+item.study.id}" class="cart-item-title">
                          {{ item.study.title }}
                        </router-link>
                      </el-col>
                      <el-col :span="6">
                        <div class="cart-item-title">{{ item.course ? item.course.title : '该科目已被删除' }}</div>
                      </el-col>
                      <el-col :span="4">
                        <el-button type="primary"
                                   v-if="Date.parse(item.study.end_time) > new Date() && item.closed !== 1"
                                   @click="goStudy(item.id)">
                          开始学习
                        </el-button>
                        <el-button v-if="Date.parse(item.study.end_time) <= new Date()" :disabled="true">
                          已过期
                        </el-button>
                        <el-button v-if="item.closed === 1" :disabled="true">
                          已关闭
                        </el-button>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
              <div class="empty" v-if="page_meta.total === 0">
                <div>
                  <img src="../../static/images/empty.png" alt="暂无数据" class="empty-img">
                  <div class="empty-title">暂无数据</div>
                </div>
              </div>
            </div>
            <div class="list-pagination" v-if="courses.length > 0">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  @current-change="handleCurrentChange"
                  :page-size="page_meta.per_page"
                  :total="page_meta.total">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="协议" :visible.sync="dialogAgreement">
      <div class="agreement-box" v-if="study && study.agreement && course">
        <div class="agreement-title">
          {{ study.agreement.title }}
        </div>
        <div class="agreement-info">
          <div class="agreement-p">
            <div>甲方：四川清瀚致远教育咨询有限公司</div>
            <div>乙方：{{ identity.name }}</div>
          </div>
          <div class="agreement-p">
            <div>联系电话：19950256252</div>
            <div>联系电话：{{ user.phone }}</div>
          </div>
          <div class="agreement-p">
            <div></div>
            <div>身份证号码：{{ identity.idcard }}</div>
          </div>
        </div>
        <div class="agreement-study">
          <p class="agreement-bold">产品相关内容</p>
          <p>购买班型：{{ study.title }}</p>
          <p>科目：{{ course.title }}</p>
          <p v-if="info.a_price > 0">金额：{{ info.a_price }}元</p>
          <p>交付方式：网站在线交付、微信小程序</p>
          <p>服务期限：{{ info.created_at }}至考试结束后3日内</p>
        </div>
        <div class="agreement-study">
          <p class="agreement-bold">协议正文</p>
          <div class="agreement-body" v-html="study.agreement.body"></div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" v-if="info.status === 0">
        <el-button type="danger" @click="dialogAgreement = false">拒绝</el-button>
        <el-button type="primary" @click="agree" v-loading.fullscreen.lock="fullscreenLoading">同意</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import TheLeft from "@/components/layouts/TheLeft";
import {authRequest} from "@/utils/request";
import {mapGetters} from "vuex";

export default {
  name: "userCourse",
  head: {
    title: "我的课程"
  },
  components: {
    TheLeft
  },
  data() {
    return {
      activeName: '0',
      path: process.env.VUE_APP_FILE,
      noneImg: process.env.VUE_APP_NONE,
      courses: [],
      page: 1,
      page_meta: [],
      loading: false,
      study: '',
      course: '',
      identity: '',
      dialogAgreement: false,
      info: ''
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  created() {
    this.getCourses()
  },
  methods: {
    handleClick(tab, event) {
      this.getCourses(true)
    },
    async getIdentity() {
      try {
        let response = await authRequest('user/identification', {
          method: 'GET'
        })
        this.identity = response.data.data
      } catch (e) {

      }
    },
    async getCourses(reset = false) {
      this.loading = true
      if (reset) {
        this.page = 1
      }
      try {
        let response = await authRequest('user/study', {
          method: 'GET',
          params: {
            page: this.page,
            type: this.activeName
          }
        })
        let courses = response.data
        this.courses = courses.data
        this.page_meta = courses.meta
        this.loading = false
      } catch (e) {

      }
    },
    handleCurrentChange(val) {
      this.page = val
      this.getCourses()
    },
    goStudy(id) {
      this.$router.push({path: '/study/' + id})
    },
    lookAgreement(index) {
      this.dialogAgreement = true
      this.getIdentity()
      this.study = this.courses[index].study
      this.course = this.courses[index].course
      this.info = this.courses[index]
    }
  }
}
</script>

<style scoped>
.order-content {
  background-color: #ffffff;
  padding: 10px 20px;
}

.order-item {
  border: 1px solid #ebebeb;
  margin-bottom: 20px;
  border-radius: 5px;
}

.order-item-header {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  font-size: 14px;
  border-bottom: 1px solid #ebebeb;
  background-color: #f3f3f3;
}

.order-box {
  min-height: 400px;
}

.order-item-content {
  padding: 20px;
  font-size: 14px;
}

.cart-item-img {
  width: 120px;
  height: 70px;
  object-fit: cover;
  border-radius: 5px;
}

.order-item-footer-status span {
  margin-left: 20px;
}

.agreement-title {
  font-size: 16px;
  color: #444;
  font-weight: bold;
  text-align: center;
}

.agreement-info {
  margin-top: 20px;
}

.agreement-p {
  display: flex;
  justify-content: space-between;
}

.agreement-p div {
  width: 48%;
}

.agreement-study {
  margin-top: 20px;
}

.agreement-bold {
  font-weight: bold;
}

.look-agreement{
  color: #555555;
  font-size: 13px;
  cursor: pointer;
}

.look-agreement:hover{
  color: #2aacb2;
}
</style>
